import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFilterPipe'
})
export class SearchFilterPipe implements PipeTransform {
  transform(items: any, filter: any, innerArray?: string): any {
    let process = 0;
    for (var key in filter) {
      if (filter[key] && filter[key] != "") {
        process = 1;
        break;
      }
    }
    let result_arr = [];
    if (process == 0 || items.length == 0) {
      return items;
    } else {
      for (var key in filter) {
        if (innerArray) {
          for (let i of items) {
            let temp_arr = JSON.parse(JSON.stringify(i));
            temp_arr[innerArray] = [];
            for (let inn of i[innerArray]) {
              let temp = inn[key].toString()
              if (temp.indexOf(filter[key].toUpperCase()) != -1) {
                temp_arr[innerArray].push(inn);
              }
            }
            if(temp_arr[innerArray].length != 0){
              result_arr.push(temp_arr);
            }
          }
        } else {
          for (let i of items) {
            let temp = i[key].toString()
            if (temp.indexOf(filter[key].toUpperCase()) != -1) {
              result_arr.push(i);
            }
          }
        }
      }
      return result_arr;
    }
  }
}